import { createAsyncAction } from 'typesafe-actions';

import { ResourceLite } from '../resources/createResource';
import { EntityBase } from '../resources/types';

import sagaApi, { Meta, PayloadApiFailure, PayloadApiRequest, PayloadApiSuccess } from './sagaApi';

export interface FetchListPayload<E extends EntityBase> extends PayloadApiRequest<E> {
  resource: ResourceLite<E>;
  method?: 'get';
  meta?: Meta<E> & {
    resultKey?: string;
  };
}

const fetchList = createAsyncAction(
  '@lib/fetchList/REQUEST',
  '@lib/fetchList/SUCCESS',
  '@lib/fetchList/FAILURE',
  '@lib/fetchList/CANCEL',
)<FetchListPayload<any>, PayloadApiSuccess<any>, PayloadApiFailure, any>();

// saga
export function* sagaFetchList(action: ReturnType<typeof fetchList.request>) {
  const {
    payload: { resource, meta, ...config },
  } = action;

  // @ts-ignore
  return yield sagaApi({
    action: fetchList,
    resource,
    url: resource.fetchListUrl,
    meta: {
      schema: resource.fetchListSchema,
      ...meta,
    },
    ...config,
  });
}

export default fetchList;
